// Textbreite MESSEN statt schätzen.
//
// Eine geschätzte Zeichenbreite (6,2 px) war im Entwurf die Ursache dafür, dass
// Beschriftungen in der Termine-Zeile ineinanderliefen. Der Browser weiß es
// genau – über ein Canvas, das nie angezeigt wird.
//
// ACHTUNG: Die Schriftangaben hier müssen zu zeitleiste.css passen. Messen wir
// mit einer anderen Schrift als wir zeichnen, stimmt die ganze Anordnung nicht.

/** wie `.termin-txt` / `.termin-balken` in zeitleiste.css */
export const SCHRIFT_TERMIN = '11px "Segoe UI", system-ui, sans-serif';
/** wie `.hdr-oben > div` in zeitleiste.css */
export const SCHRIFT_KOPF = '600 12px "Segoe UI", system-ui, sans-serif';

const messer = document.createElement("canvas").getContext("2d");
const bekannt = new Map<string, number>();

export function textBreite(text: string, schrift: string = SCHRIFT_TERMIN): number {
  const schluessel = `${schrift}|${text}`;
  const gemerkt = bekannt.get(schluessel);
  if (gemerkt !== undefined) return gemerkt;

  let breite: number;
  if (messer) {
    messer.font = schrift;
    breite = messer.measureText(text).width;
  } else {
    // Ohne Canvas lieber großzügig schätzen als abstürzen: Die Zeitleiste wird
    // dann luftiger, aber nichts überlappt.
    breite = text.length * 7;
  }
  bekannt.set(schluessel, breite);
  return breite;
}
